import familhao from "../../../../assets/images/familhao-light.png";
import socialNetworks from "../../../../assets/images/group-social.svg";
import "./FamilhaoFooter.scss";

const FamilhaoFooter = () => {
  return (
    <>
      <div className="redemption-code-sub-footer"></div>
      <div className="redemption-code-footer flex-column">
        <div className="row justify-content-between">
          <div className="redemption-code-footer-logo col-sm">
            <img src={familhao} alt="mi" />
          </div>
          <div className="redemption-code-footer-social col-md">
            <img src={socialNetworks} alt="familhao" />
          </div>
        </div>

        <div className="footer-line row"></div>
        <div className="footer-address row">
          <span>
            Alameda Rio Negro, 585, 13º Andar. Alphaville, Barueri, SP. CEP
            06454-000.
          </span>
          <div className="footer-links">
            <span>
              {" "}
              <a target="_blank" href="#" rel="noreferrer">
                Descadastrar-se
              </a>{" "}
              |
              <a target="_blank" href="#" rel="noreferrer">
                Política de Privacidade
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default FamilhaoFooter;
